export default __webpack_public_path__ + "static/media/bowie59.85a044aa.webp";